<template>
    <div class="dataImport">
        <el-row>
            <!-- 面包屑 -->
            <el-col :span="24"><Breadcrumbs :arr="['碳汇管理平台','数据导入']" /></el-col>
            <!-- 查询表单 -->
            <el-col class="search" :span="24">
                <el-form :inline="true" :model="search" class="demo-form-inline">
                    <!-- <el-form-item label="主题">
                        <el-input
                        size="small"
                        v-model="search.policyTheme"
                        maxlength="100"
                        clearable
                        placeholder="请输入"
                        class="inline-input"
                        ></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="组织名称">
                        <el-cascader
                        ref="chooseOs"
                        :options="options"
                        @change='searchOrgChange'
                        :props="{ checkStrictly: true }"
                        :show-all-levels="false"
                        ></el-cascader>
                    </el-form-item> -->
                    <!-- <el-form-item label="发布类型">
                        <el-select
                        v-model="search.type"
                        clearable
                        placeholder="请选择"
                        size="small"
                        >
                        <el-option label="政策学习" :value="0"> </el-option>
                        <el-option label="宣传报道" :value="1"> </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item id="time" label="日期">
                        <!-- <el-date-picker
                        v-model="search.time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        align="right"
                        style="width:280px;"
                        unlink-panels
                        size="small"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        >
                        </el-date-picker> -->
                        <el-date-picker
                        v-model="search.startYear"
                        type="year"
                        size="small"
                        format="yyyy"
                        value-format="yyyy"
                        :picker-options="pickerOptionsYear"
                        style="width: 200px"
                        placeholder="开始日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-date-picker
                        v-model="search.endYear"
                        type="year"
                        size="small"
                        format="yyyy"
                        :picker-options="pickerOptionsYear1"
                        value-format="yyyy"
                        style="width: 200px"
                        placeholder="结束日期"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="btn">
                        <!-- class="theme-btn" -->
                        <el-button
                        size="small"
                        type="primary"
                        @click="getList"
                        round
                        >查询</el-button
                        >
                        <el-button
                        size="small"
                        style="margin: 0 0 0 50px"
                        @click="reset"
                        round
                        type="info"
                        >重置</el-button
                        >
                    </el-form-item>
                </el-form>
            </el-col>
            <!-- 表格数据 -->
            <el-col class="main_table" :span="24">
                <div class="table_btn">
                    <div class="">
                        <el-button
                        size="small"
                        :type="type==0?'primary':''"
                        @click="changeTab(0)"
                        >碳排贡献量</el-button>
                        <el-button
                        size="small"
                        @click="changeTab(1)"
                        :type="type==1?'primary':''"
                        >碳吸收贡献量</el-button>
                        <el-button
                        size="small"
                        @click="changeTab(2)"
                        :type="type==2?'primary':''"
                        >碳吸收贡献率</el-button>
                        <el-button
                        size="small"
                        @click="changeTab(3)"
                        :type="type==3?'primary':''"
                        >各行业碳排数据</el-button>
                        <el-button
                        size="small"
                        @click="changeTab(4)"
                        :type="type==4?'primary':''"
                        >历年碳排数据</el-button>
                        <el-button
                        size="small"
                        @click="changeTab(5)"
                        :type="type==5?'primary':''"
                        >年度碳排数据</el-button>
                    </div>
                    <el-button
                        size="small"
                        type="primary"
                        @click="isAddData"
                        round
                        >新增</el-button
                    >
                </div>
                <div v-if="type == 0">
                    <Tables class="table" :columns="table.columns" :loading="table.loading" :tableData="table.tableData" >
                        <template #sum="scope"><div>{{sum(scope.row)}}</div></template>
                        <template #transportationScale="scope"><div>{{sum(scope.row,scope.row.transportation)}}</div></template>
                        <template #industrialScale="scope"><div>{{sum(scope.row,scope.row.industrial)}}</div></template>
                        <template #agricultureScale="scope"><div>{{sum(scope.row,scope.row.agriculture)}}</div></template>
                        <template #otherIndustrieScales="scope"><div>{{sum(scope.row,scope.row.otherIndustries)}}</div></template>
                        <template #actions="scope">
                            <div class="flex">
                                <!-- <span class="theme-color">修改</span>
                                <span class="theme-color">删除</span>
                                <span class="theme-color">详情</span> -->
                                <el-button type="text" @click="isEdit(scope.row.id)">修改</el-button>
                                <el-button type="text" @click="isDelete(scope.row.id)">删除</el-button>
                                <el-button type="text" @click="isView(scope.row.id)">详情</el-button>
                            </div>
                        </template>
                    </Tables>
                    <Paginations :pageData="table.pageData" :sizeChange="sizeChange" :currentChange="currentChange"  />
                </div>
                <div v-else-if="type == 1">
                    <Tables class="table" :columns="table1.columns" :loading="table1.loading" :tableData="table1.tableData" >
                        <template #sum="scope"><div>{{sum(scope.row)}}</div></template>
                        <template #teaCoffeeScales="scope"><div>{{sum(scope.row,scope.row.teaCoffee)}}</div></template>
                        <template #biogasManureScales="scope"><div>{{sum(scope.row,scope.row.biogasManure)}}</div></template>
                        <template #plantedForestScales="scope"><div>{{sum(scope.row,scope.row.plantedForest)}}</div></template>
                        <template #naturalForestScales="scope"><div>{{sum(scope.row,scope.row.naturalForest)}}</div></template>
                        <template #hydropowerScales="scope"><div>{{sum(scope.row,scope.row.hydropower)}}</div></template>
                        <template #actions="scope">
                            <div class="flex">
                                <!-- <span class="theme-color">修改</span>
                                <span class="theme-color">删除</span>
                                <span class="theme-color">详情</span> -->
                                 <el-button type="text" @click="isEdit(scope.row.id)">修改</el-button>
                                <el-button type="text" @click="isDelete(scope.row.id)">删除</el-button>
                                <el-button type="text" @click="isView(scope.row.id)">详情</el-button>
                            </div>
                        </template>
                    </Tables>
                    <Paginations :pageData="table1.pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
                </div>
                <div v-else-if="type == 2">
                    <Tables class="table" :columns="table2.columns" :loading="table2.loading" :tableData="table2.tableData" >
                        <template #sum="scope"><div>{{sum(scope.row)}}</div></template>
                        <template #biogasManureScales="scope"><div>{{sum(scope.row,scope.row.biogasManure)}}</div></template>
                        <template #teaCoffeeScales="scope"><div>{{sum(scope.row,scope.row.teaCoffee)}}</div></template>
                        <template #plantedForestScales="scope"><div>{{sum(scope.row,scope.row.plantedForest)}}</div></template>
                        <template #naturalForestScales="scope"><div>{{sum(scope.row,scope.row.naturalForest)}}</div></template>
                        <template #hydropowerScales="scope"><div>{{sum(scope.row,scope.row.hydropower)}}</div></template>
                        <template #actions="scope">
                            <div class="flex">
                                <!-- <span class="theme-color">修改</span>
                                <span class="theme-color">删除</span>
                                <span class="theme-color">详情</span> -->
                                <el-button type="text" @click="isEdit(scope.row.id)">修改</el-button>
                                <el-button type="text" @click="isDelete(scope.row.id)">删除</el-button>
                                <el-button type="text" @click="isView(scope.row.id)">详情</el-button>
                            </div>
                        </template>
                    </Tables>
                    <Paginations :pageData="table2.pageData" :sizeChange="sizeChange" :currentChange="currentChange"  />
                </div>
                <div v-else-if="type == 3">
                    <Tables class="table" :columns="table3.columns" :loading="table3.loading" :tableData="table3.tableData" >
                        <template #actions="scope">
                            <div class="flex">
                                <!-- <span class="theme-color">修改</span>
                                <span class="theme-color">删除</span>
                                <span class="theme-color">详情</span> -->
                                 <el-button type="text" @click="isEdit(scope.row.id)">修改</el-button>
                                <el-button type="text" @click="isDelete(scope.row.id)">删除</el-button>
                                <el-button type="text" @click="isView(scope.row.id)">详情</el-button>
                            </div>
                        </template>
                    </Tables>
                    <Paginations :pageData="table3.pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
                </div>
                <div v-else-if="type == 4">
                    <Tables class="table" :columns="table4.columns" :loading="table4.loading" :tableData="table4.tableData" >
                        <template #actions="scope">
                            <div class="flex">
                                <!-- <span class="theme-color">修改</span>
                                <span class="theme-color">删除</span>
                                <span class="theme-color">详情</span> -->
                                 <el-button type="text" @click="isEdit(scope.row.id)">修改</el-button>
                                <el-button type="text" @click="isDelete(scope.row.id)">删除</el-button>
                                <el-button type="text" @click="isView(scope.row.id)">详情</el-button>
                            </div>
                        </template>
                    </Tables>
                    <Paginations :pageData="table4.pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
                </div>
                <div v-else-if="type == 5">
                    <Tables class="table" :columns="table5.columns" :loading="table5.loading" :tableData="table5.tableData" >
                        <template #actions="scope">
                            <div class="flex">
                                <!-- <span class="theme-color">修改</span>
                                <span class="theme-color">删除</span>
                                <span class="theme-color">详情</span> -->
                                <el-button type="text" @click="isEdit(scope.row.id)">修改</el-button>
                                <el-button type="text" @click="isDelete(scope.row.id)">删除</el-button>
                                <el-button type="text" @click="isView(scope.row.id)">详情</el-button>
                            </div>
                        </template>
                    </Tables>
                    <Paginations :pageData="table5.pageData" :sizeChange="sizeChange" :currentChange="currentChange" />
                </div>
            </el-col>
        </el-row>
        <modaDialogl :dialog="dialog" :handleClose="handleClose" :form="form" :form1="form1" :isView="isShowView" :type="type" />
        
    </div>
</template>
<script>
import {
    getCarbonEmissionList,getCarbonEmissionDetail,delCarbonEmissionInfo ,getCarbonUptakeList,getCarbonUptakeDetail,delCarbonUptakeInfo,
    getCarbonEmissionReductionsList,getCarbonEmissionReductionsDetail,delCarbonEmissionReductionsInfo,
    getIndustryCarbonEmissionsList,getIndustryCarbonEmissionsDetail,delIndustryCarbonEmissionsInfo,
    getCarbonEmissionsOverTimeList,getCarbonEmissionsOverTimeDetail,delCarbonEmissionsOverTimeInfo,
    getAnnualCarbonEmissionsList,getAnnualCarbonEmissionsDetail,delAnnualCarbonEmissionsInfo
    } from "@/api/api";
import Breadcrumbs from "@/components/breadcrumbs/breadcrumbs.vue"
import Tables from "@/components/tables/tables.vue"
import modaDialogl from "./components/modaDialogl.vue"
import Paginations from "@/components/paginations/paginations.vue"
import {columns,columns1,columns2, columns3, columns4,columns5} from "./js/columns"
export default {
    name:"dataImport",
    data(){
        return{
            search: {
               "endYear": "",
                "policyTheme": "",
                "startYear": "",
                "type": ""
            },
            //日期选择范围在一个月内
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                this.selectDate = minDate.getTime();
                if (maxDate) {
                    this.selectDate = "";
                }
                },
                disabledDate: (time) => {
                if (this.selectDate !== "") {
                    const one = 30 * 24 * 3600 * 1000;
                    const minTime = this.selectDate - one;
                    const maxTime = this.selectDate + one;
                    return time.getTime() < minTime || time.getTime() > maxTime;
                }
                },
            },
            pickerOptions1: {
                disabledDate: (time) => {
                const start = Date.parse(this.search.startDate);
                const end = Date.parse(this.search.endDate);
                if (this.search.endDate) {
                    return time.getTime() > Date.now() || time.getTime() > end;
                } else {
                    return time.getTime() > Date.now();
                }
                },
            },
            pickerOptions2: {
                disabledDate: (time) => {
                const start = Date.parse(this.search.startDate);
                const end = Date.parse(this.search.endDate);
                if (this.search.startDate) {
                    return (
                    time.getTime() < start - 1000 * 60 * 60 * 24
                    );
                } else {
                    // return time.getTime() > Date.now();
                }
                },
            },
            // 碳排贡献量
            table:{
                // 表格展示数据
                tableData:[],
                // 表格显示标题
                columns:[],
                // 表格是否加载中
                loading:false,
                // 分页 
                pageData:{
                  size: 10, 
                  page: 1, 
                  total: 1 
                },
            },
            // 碳吸收贡献量
            table1:{
                // 表格展示数据
                tableData:[],
                // 表格显示标题
                columns:[],
                // 表格是否加载中
                loading:false,
                // 分页 
                pageData:{
                  size: 10, 
                  page: 1, 
                  total: 1 
                },
            },
            // 碳减排贡献量
            table2:{
                // 表格展示数据
                tableData:[],
                // 表格显示标题
                columns:[],
                // 表格是否加载中
                loading:false,
                // 分页 
                pageData:{
                  size: 10, 
                  page: 1, 
                  total: 1 
                },
            },
            // 各行业碳排数据
            table3:{
                // 表格展示数据
                tableData:[],
                // 表格显示标题
                columns:[],
                // 表格是否加载中
                loading:false,
                // 分页 
                pageData:{
                  size: 10, 
                  page: 1, 
                  total: 1 
                },
            },
            // 历年碳排数据
            table4:{
                // 表格展示数据
                tableData:[],
                // 表格显示标题
                columns:[],
                // 表格是否加载中
                loading:false,
                // 分页 
                pageData:{
                  size: 10, 
                  page: 1, 
                  total: 1 
                },
            },
            // 年度碳排数据
            table5:{
                // 表格展示数据
                tableData:[],
                // 表格显示标题
                columns:[],
                // 表格是否加载中
                loading:false,
                // 分页 
                pageData:{
                  size: 10, 
                  page: 1, 
                  total: 1 
                },
            },
            // 弹出框设置
            dialog:{
                size: 720,
                visible: false,
                title: "新增",
            },
            // 是否显示操作按钮
            isShowView:true,
            // 用户信息
            userInfo:{},
            // 
            type:0,
            // 碳排贡献量
            form:{
                year:'', // 年份
                transportation:'', // 交通运输排放量
                industrial:'', // 工业排放量
                agriculture:'', // 农业排放量
                otherIndustries:'', // 其他行业排放量
            },
            // 碳吸收贡献量
            form1:{
                year:'', // 年份
                teaCoffee:'', // 茶叶咖啡种植
                biogasManure:'', // 沼气粪肥量
                plantedForest:'', // 人工林
                naturalForest:'', // 天然林
                hydropower:'', // 水电
            },
            pickerOptionsYear: {
                disabledDate: (time) => {
                const start = Date.parse(this.search.startYear);
                const end = Date.parse(this.search.endYear);
                if (this.search.endYear) {
                    return time.getTime() > Date.now() || time.getTime() > end;
                } else {
                    return time.getTime() > Date.now();
                }
                },
            },
            pickerOptionsYear1: {
                disabledDate: (time) => {
                    const start = Date.parse(this.search.startYear);
                    const end = Date.parse(this.search.endYear);
                    if (this.search.startYear) {
                    return (
                        time.getTime() < start - 8.64e7
                    );
                    } else {
                    // return time.getTime() > Date.now();
                    }
                },
            },
        }
    },
    methods:{
        // 页面初始化
        init(){
            this.table.columns = columns
            this.table1.columns = columns1
            this.table2.columns = columns2
            this.table3.columns = columns3
            this.table4.columns = columns4
            this.table5.columns = columns5
            this.getList()
        },
        // 获取数据列表
        async getList(){
            let arrTab = [this.table,this.table1,this.table2,this.table3,this.table4,this.table5]
            let arrFun = [getCarbonEmissionList,getCarbonUptakeList,getCarbonEmissionReductionsList,getIndustryCarbonEmissionsList,getCarbonEmissionsOverTimeList,getAnnualCarbonEmissionsList]
            let page = {
                current: arrTab[this.type].pageData.page,
                size: arrTab[this.type].pageData.size,
            };
            arrTab[this.type].loading = true
            const res = await arrFun[this.type](this.search, page)
            if(res.data.code == 200){
                arrTab[this.type].tableData = res.data.data.records
                arrTab[this.type].pageData.total = res.data.data.total
            }
            arrTab[this.type].loading = false
        },
        // 点击重置
        reset(){
            this.search = {
               "endYear": "",
                "policyTheme": "",
                "startYear": "",
                "type": ""
            }
            this.getList()
        },
        changeTab(val){
            this.type = val
            let arrTab = [this.table,this.table1,this.table2,this.table3,this.table4,this.table5]
            arrTab[val].tableData = []
            this.getList()
        },
        // 
        sizeChange(val){
            let arrTab = [this.table,this.table1,this.table2,this.table3,this.table4,this.table5]
            arrTab[this.type].pageData.size = val
            this.getList()
        },
        // 
        currentChange(val){
            let arrTab = [this.table,this.table1,this.table2,this.table3,this.table4,this.table5]
            arrTab[this.type].pageData.page = val
            this.getList()
        },
        // 关闭弹出框
        handleClose(){
            this.dialog.visible = false
        },
        // 新增
        isAddData(){
            if(this.type==0){
                this.form = {
                    year:'', // 年份
                    transportation:'', // 交通运输排放量
                    industrial:'', // 工业排放量
                    agriculture:'', // 农业排放量
                    otherIndustries:'', // 其他行业排放量
                }
            }else if(this.type==1){
                this.form = {
                    year:'', // 年份
                    teaCoffee:'', // 茶叶咖啡种植
                    biogasManure:'', // 沼气粪肥量
                    plantedForest:'', // 人工林
                    naturalForest:'', // 天然林
                    hydropower:'', // 水电
                }
            }else if(this.type==2){
                this.form = {
                    year:'', // 年份
                    teaCoffee:'', // 茶叶咖啡种植
                    biogasManure:'', // 沼气粪肥量
                    plantedForest:'', // 人工林
                    // naturalForest:'', // 天然林
                    hydropower:'', // 水电
                }
            }else if(this.type==3){
                this.form = {
                    year:'', // 年份
                    greatIndustry:'', // 大工业
                    generalIndustrial:'', // 非普工业
                    business:'', // 商业
                    residentsLiving:'', // 居民生活
                    aquaculture:'', // 养殖业
                    transportationIndustry:'', // 交通运输业
                    residentPhotograph:'', // 非居民照明
                    agriculturalProduction:'', // 农业生产
                    agriculturalDrainage:'', // 农业排灌
                }
            }else if(this.type==4){
                this.form = {
                    year:'', // 年份
                    industrialProduction:'', // 工业生产
                    agriculturalProduction:'', // 农业生产
                    transportation:'', // 交通运输
                    otherIndustries:'', // 其他行业
                }
            }else if(this.type==5){
                this.form = {
                    year:'', // 年份
                    totalCarbonEmission:'', // 碳排放总量
                    totalCarbonAbsorption:'', // 碳吸收总量（包括天然林）
                    offsetTotalCarbonAbsorption:'', // 可供抵消的碳吸收总量
                }
            }
            this.dialog.visible = true
            this.isShowView = true
            this.dialog.title = '新增'
        },
        // 修改
        async isEdit(id){
            const funArr = [getCarbonEmissionDetail,getCarbonUptakeDetail,getCarbonEmissionReductionsDetail,getIndustryCarbonEmissionsDetail,getCarbonEmissionsOverTimeDetail,getAnnualCarbonEmissionsDetail]
            const res = await funArr[this.type](id)
            if(res.data.code == 200)
                this.form = res.data.data
            this.dialog.visible = true
            this.isShowView = true
            this.dialog.title = '修改'
        },
        // 详情
        async isView(id){
            const funArr = [getCarbonEmissionDetail,getCarbonUptakeDetail,getCarbonEmissionReductionsDetail,getIndustryCarbonEmissionsDetail,getCarbonEmissionsOverTimeDetail,getAnnualCarbonEmissionsDetail]
            const res = await funArr[this.type](id)
            if(res.data.code == 200)
                this.form = res.data.data
            this.dialog.visible = true
            this.dialog.title = '详情'
            this.isShowView = false
        },
        // 删除
        isDelete(id){
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const delArr = [delCarbonEmissionInfo,delCarbonUptakeInfo,delCarbonEmissionReductionsInfo,delIndustryCarbonEmissionsInfo,delCarbonEmissionsOverTimeInfo,delAnnualCarbonEmissionsInfo]
                const arrTab = [this.table,this.table1,this.table2,this.table3,this.table4,this.table5]
                delArr[this.type](id).then(res=>{
                    if(res.data.code == 200){ 
                        if (arrTab[this.type].tableData.length == 1) {
                            let page = arrTab[this.type].pageData.page - 1;
                            page = page <= 0 ? 0 : page;
                            arrTab[this.type].pageData.page = page;
                        }
                        this.getList()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        sum(row,el){
            const reg = /([0-9]+\.[0-9]{2})[0-9]*/;
            if(this.type == 0){
                var {otherIndustries=0,agriculture=0,industrial=0,transportation = 0} = row
                var sum = (otherIndustries + agriculture + industrial + transportation + '').replace(reg,"$1")
            }else if(this.type == 1||this.type == 2){
                 var {teaCoffee=0,biogasManure=0,plantedForest=0,naturalForest = 0,hydropower=0} = row
                var sum = (teaCoffee + biogasManure + plantedForest + naturalForest + hydropower + '').replace(reg,"$1")
            }
            if(el == 0) return 0 +'%'
            if(!(el=='' || el==undefined  || el== null)){
                let n = (el / sum) * 100 + ''
                n = n.replace(reg,"$1")
                return n + '%'
            }else 
                return sum 
        },

    },
    mounted(){
        this.init()
    },
    components:{
        Breadcrumbs,
        Tables,
        modaDialogl,
        Paginations,
    },
}
</script>
<style scoped>
    .flex{
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    .home_main .main_table .table_btn{
        display: flex;
        align-items: center;
        justify-content: space-between ;
    }
</style>